export const isOverflownX = element => {
  if (element) {
    const { clientWidth, scrollWidth } = element;

    return scrollWidth > clientWidth;
  } else return false;
};
